import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import withTranslation from "@template/components/translation";
import InfoBanner from "@template/components/InfoBanner/index";
import BagLinks from "@template/components/MiniBag/Footer/BagLinks";
import IconButton from "@template/components/IconButton";
import { tabIndex } from "@src/helpers/accessibility";

import styles from "./index.css";

class ReservationMessage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hide: false
    };

    this.lastActiveElement;
    this.closeButton;
  }

  componentDidMount() {
    this.lastActiveElement = document.activeElement;
  }

  handleClose = () => {
    this.lastActiveElement && this.lastActiveElement.focus();
    this.setState({
      hide: true
    });
  };

  /* istanbul ignore next */
  hasShownCallback = () => {
    this.props.bagBannerShown();
    this.setState({
      hide: false
    });
  };

  focusClose = refToMountedElement => {
    this.closeButton = refToMountedElement;
    this.closeButton && this.closeButton.focus();
  };

  render() {
    const {
      showBagBanner,
      formatTranslation,
      bagBannerShown,
      sellerChanged,
      showCTAS
    } = this.props;

    const message = sellerChanged
      ? "dtc_atb_reservation_sellerchangemessage"
      : "minibag_reservation_message";

    return showCTAS ? (
      <InfoBanner
        cosmeticStyles={{
          background: styles.background
        }}
        hasShownCallback={this.hasShownCallback}
        message={formatTranslation(message)}
        shouldShow={showBagBanner}
        forceHide={this.state.hide}
      >
        <IconButton
          aria-label={formatTranslation("icon_close")}
          icon={styles.close}
          size="small"
          className={styles.closeContainer}
          tabIndex={tabIndex(!this.state.hide)}
          onClick={this.handleClose}
          refCallback={this.focusClose}
        />
        <BagLinks useMvtStyles={true} />
      </InfoBanner>
    ) : (
      <InfoBanner
        cosmeticStyles={{
          background: styles.background
        }}
        hasShownCallback={bagBannerShown}
        message={formatTranslation(message)}
        shouldShow={showBagBanner}
      ></InfoBanner>
    );
  }
}

ReservationMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  bagBannerShown: PropTypes.func.isRequired,
  showBagBanner: PropTypes.bool.isRequired,
  sellerChanged: PropTypes.bool,
  showCTAS: PropTypes.bool
};

export default withTranslation(ReservationMessage);
